export const METRICS_GROUP_BY_API_PARAMS = {
  // groupBy supported params to be send to /search metrics api
  CONTRIBUTOR: 'contributor',
  TEAM: 'team',
  REPOSITORY: 'repository',
  SERVICE: 'service',
  ORGANIZATION: 'organization',
  CUSTOM_METRIC: 'custom_metric'
};
